import TrackingUtils from "@tracking/utils/TrackingUtils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { openToast } from "app/store/trackingApp/toastSlice";

export const getDataTriagemTipo = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemTipo",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/triagem/tipo", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getVariaveisTriagemStatus = createAsyncThunk(
  "triagemApp/triagem/getVariaveisTriagemStatus",
  async (_, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/variavel-tabelas", {
        params: { idVariavel: 38 },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getDataTriagemIndicadoresTMS = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemIndicadoresTMS",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.get("/triagem/indicadores/tms", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    return response.data;
  }
);

export const getDataTriagemIndicadoresCodigoOcorrencia = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemIndicadoresCodigoOcorrencia",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.get("/triagem/indicadores/codigoOcorrencia", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    return response.data;
  }
);

export const getDataTriagemIndicadoresTipo = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemIndicadoresTipo",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.get("/triagem/indicadores/tipo", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    return response.data;
  }
);

export const getDataTriagemIndicadoresTransportadora = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemIndicadoresTransportadora",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/triagem/indicadores/transportadora", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getDataTriagemOcorrencias = createAsyncThunk(
  "triagemApp/triagem/getDataTriagemOcorrencias",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.get("/triagem/ocorrencias", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    return response.data;
  }
);

export const updateOcorrencia = createAsyncThunk(
  "triagemApp/triagem/updateOcorrencia",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.put("/triagem/ocorrencias", null, { params: data });
      dispatch(
        openToast({
          severity: "success",
          title: "Reprocessado com sucesso",
        })
      );
    } catch (err: any) {
      dispatch(
        openToast({
          severity: "error",
          title: "Não foi possível reprocessar",
        })
      );
    }
    return response.data;
  }
);

export const updateOcorrencias = createAsyncThunk(
  "triagemApp/triagem/updateOcorrencias",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API.put(
        TrackingUtils.buildQueryStringArray("/triagem/ocorrencias", data),
        null
      );
      const messsage = response.data.messages[0].text;
      dispatch(
        openToast({
          severity: "info",
          title: `Reprocessamento iniciado, ${messsage}`,
        })
      );
    } catch (err: any) {
      dispatch(
        openToast({
          severity: "error",
          title: "Não foi possível reprocessar",
        })
      );
    }
    return response.data;
  }
);
